import { Box, Button, Group, Text, Textarea, useMantineTheme } from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import classes from "./CaptureNoteEditor.module.scss";

export const NoteEditorState = {
    EDITING: "editing",
    SAVING: "saving",
    CANCELLED: "cancelled",
}

export function CaptureNoteEditor({ notes, onNotesChange, defaultState }) {
    const [editingValue, setEditingValue] = useState(notes || "");
    const [isEditing, setIsEditing] = useState(defaultState && defaultState === NoteEditorState.EDITING?true:false);
    const theme = useMantineTheme();
    const inputRef = useRef(null);
    const handleClick = () => {
      setIsEditing(true);
    };

    useEffect(() => {
      if (inputRef.current && isEditing) {
        setTimeout(() => {
          inputRef.current.focus();
        }, 100);
      }
    }, []);
  
    const handleChange = (event) => {
      setEditingValue(event.target.value);
    };
  
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && event.ctrlKey) {
        // Ctrl+Enter to save
        handleSave();
      } else if (event.key === "Escape") {
        // Escape to cancel
        handleCancel();
      }
    };
  
    const handleSave = () => {
      if (onNotesChange) {
        onNotesChange(editingValue);
      }
      setIsEditing(false);
    };
  
    const handleCancel = () => {
      setEditingValue(notes || "");
      setIsEditing(false);
    };
  
    const handleBlur = () => {
      // Auto-save on blur
      // handleSave();
      // setIsEditing(false);
    };
  
    useEffect(() => {
      setEditingValue(notes || "");
    }, [notes]);
  
    if (isEditing) {
      return (
        <Box className={`${classes.captureNoteEditor} ${classes.editing}`}>
          <Textarea
            value={editingValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            autoFocus
            minRows={3}
            placeholder="Add your notes here... (Press Esc to cancel)"
            ref={inputRef}
          />
          <Group mt="xs" gap="xs">
            <Button size="xs" onClick={handleSave}>
              Save
            </Button>
            <Button size="xs" variant="default" onClick={handleCancel}>
              Cancel
            </Button>
            <Text size="xs" c="dimmed">
              Press Esc to cancel
            </Text>
          </Group>
        </Box>
      );
    }
  
    return (
      <Box
        onClick={handleClick}
        className={classes.captureNoteEditor}
      >
        {notes && notes.trim() ? (
          <Text className={classes.text} size="sm" style={{ whiteSpace: 'pre-wrap' }}>
            {notes}
          </Text>
        ) : (
          <Text size="sm" c="dimmed" fs="italic">
            Click to add notes...
          </Text>
        )}
      </Box>
    );
  }
  